"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluAnalysisProgressSchema = void 0;
exports.pluAnalysisProgressOf = pluAnalysisProgressOf;
const zod_1 = require("zod");
// #308 — où en est l'analyse du PLU d'une étude.
//
// Le worker l'écrit dans `jobs.output.progress` tant que l'analyse tourne ; à la
// fin, `MonitorJob` remplace `output` par le résultat. L'éditeur V2 le lit pour
// le voile posé sur le formulaire : l'étape, la section en cours, et l'heure de
// fin estimée — d'abord sur le nombre de pages du règlement, puis sur le rythme
// des sections déjà lues.
exports.PluAnalysisProgressSchema = zod_1.z.object({
    /** L'étape en cours, telle que le job la nomme (« analyse de la zone UA », un titre de section…). */
    step: zod_1.z.string(),
    /** Pages du règlement lu (dispositions générales comprises) ; null tant qu'il n'est pas téléchargé. */
    pages: zod_1.z.number().int().nonnegative().nullable(),
    /** Sections du questionnaire déjà parcourues, et leur total ; null avant la première. */
    sectionsDone: zod_1.z.number().int().nonnegative().nullable(),
    sectionsTotal: zod_1.z.number().int().positive().nullable(),
    /** Fin estimée (ISO 8601) ; null tant qu'on ne peut rien dire. */
    estimatedEndAt: zod_1.z.string().nullable(),
});
/** La progression portée par `jobs.output`, ou null (pas encore écrite, ou déjà remplacée par le résultat). */
function pluAnalysisProgressOf(output) {
    if (output === null || typeof output !== 'object')
        return null;
    const parsed = exports.PluAnalysisProgressSchema.safeParse(output.progress);
    return parsed.success ? parsed.data : null;
}
//# sourceMappingURL=pluAnalysisProgress.js.map